export default __webpack_public_path__ + "static/media/workwithus_video.8b7893c7.mp4";